var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_365_19230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9136 12.9086C11.1216 12.9086 13.7222 10.308 13.7222 7.10007C13.7222 3.89209 11.1216 1.2915 7.9136 1.2915C4.70562 1.2915 2.10504 3.89209 2.10504 7.10007C2.10504 10.308 4.70562 12.9086 7.9136 12.9086Z",
    stroke: "#F93A2F",
    strokeWidth: 1.16171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9136 4.77637V7.09979",
    stroke: "#F93A2F",
    strokeWidth: 1.16171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9136 9.42334H7.91941",
    stroke: "#F93A2F",
    strokeWidth: 1.16171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_365_19230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9406,
    height: 13.9406,
    fill: "white",
    transform: "translate(0.943329 0.129883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.3cc6c5dc0276b6e4accaec8b440dc881.svg";
export { ForwardRef as ReactComponent };